import React, { Fragment } from 'react';
import T from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import {
  changeInput,
  changeStep,
  resetInputs,
} from '@dmi/shared/redux/Register/Main/actions';

import Consent from '../../../components/Consent';
import { SecondaryHeader } from '../../../components/ScreenHeaders';

const ConsentView = ({
  dispatchChangeInput,
  dispatchChangeStep,
  dispatchResetInputs,
  formInputProps: {
    formValues,
    step,
  },
  viewCardProps: {
    formName,
    mobilePath,
    pageHeader,
    secondaryButtonLabel,
    submitLabel,
  },
}) => {
  const handleCancelPress = () => {
    dispatchResetInputs();
  };

  const handleCheckboxPress = (field, value) => dispatchChangeInput({
    field,
    form: formName,
    value,
  });

  const handleSubmitPress = () => dispatchChangeStep(step + 1);

  return (
    <Fragment>
      <SecondaryHeader title={pageHeader} />
      <Consent
        formValues={formValues}
        handleCancelPress={handleCancelPress}
        handleCheckboxPress={handleCheckboxPress}
        handleSubmitPress={handleSubmitPress}
        path={mobilePath}
        secondaryButtonLabel={secondaryButtonLabel}
        submitLabel={submitLabel}
      />
    </Fragment>
  );
};

ConsentView.propTypes = {
  dispatchChangeInput: T.func.isRequired,
  dispatchChangeStep: T.func.isRequired,
  dispatchResetInputs: T.func.isRequired,
  formInputProps: T.shape({
    formValues: T.object.isRequired,
    step: T.number.isRequired,
  }),
  viewCardProps: T.shape({
    formName: T.string.isRequired,
    mobilePath: T.string.isRequired,
    pageHeader: T.string.isRequired,
    secondaryButtonLabel: T.string.isRequired,
    submitLabel: T.string.isRequired,
  }),
};

const mapDispatchToProps = (dispatch) => ({
  /**
  * Store : Register
  */
  dispatchChangeInput: (payload) => dispatch(changeInput(payload)),
  dispatchChangeStep: (payload) => dispatch(changeStep(payload)),
  dispatchResetInputs: () => dispatch(resetInputs()),
});

const withConnect = connect(null, mapDispatchToProps);

export default compose(withConnect)(ConsentView);
